import React, { useEffect, useState } from "react"; 
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import {
  get_GemstoneCategory_GetDropDawnData,
  get_Gemstone_GetData_GemData,
  get_Gemstone_Singledata,
} from "../../../store/actions/CommanAction";
import user from "./../../../images/task/user.jpg";
import DatePicker from "react-datepicker";
import {
  editorConfig,
  getShowingDateText,
  getShowingMonthDateYear,
  ReactQuillFormats,
  ReactQuillModules,
} from "../Utility/Utility";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { Link, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import { ClassicEditor } from "ckeditor5";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const quillBorderedStyle = `
.form-card input:focus, .form-card textarea:focus, .form-card select:focus {
  border-color: #fdba74 !important;
  box-shadow: 0 0 0 2px rgba(253, 186, 116, 0.2) !important;
  outline: none !important;
}
.form-card input, .form-card textarea, .form-card select {
//   border: 1px solid #fdba74 !important;
  border-radius: 6px !important;
  font-size: 14px;
  background: #fff;
}
.quill-bordered .ql-container {
  border: 1px solid #fdba74 !important;
  border-radius: 6px !important;
  background: #fff !important;
  font-size: 14px;
}
.quill-bordered .ql-toolbar {
  border: 1px solid #fdba74 !important;
  border-bottom: none !important;
  border-radius: 6px 6px 0 0 !important;
}
.quill-bordered .ql-container.ql-snow {
  border-radius: 0 0 6px 6px !important;
}
`;

const GemstoneAdd = ({ onClose, modalOpen }) => {
  const dispatch = useDispatch();
  const navigate=useNavigate()
  const GemstoneSingledata = useSelector(
    (state) => state.feedBackReducer.GemstoneSingledata
  );
  const GemstoneCategoryGetDropDawnData = useSelector(
    (state) => state.feedBackReducer.GemstoneCategoryGetDropDawnData
  );
  const GemstoneGetDataGemData = useSelector(
    (state) => state.feedBackReducer.GemstoneGetDataGemData
  );
  const GemstoneID = useSelector((state) => state.feedBackReducer.GemstoneID);
  const [EditValue, setEditValue] = useState();
  const [file, setFile] = React.useState(null);
  const [IsActive, setIsActive] = useState(true);

  const [Value, SetValue] = useState({
    HeadingDescription: "",
    CategoryID: "",
    Category: "",
    originalPrice: "",
    Discount: "", //added
    CurrentPrice: "",
    GSTAmt: "",
    GSTinfo: "",
    TotalAmt: "",
    Carat: "",
    Ratti: "",
    IsActive: true, // Status

    DetailDescription: "",
    DetailDescriptionDoc: "", // text
    ShortDescription: "", // html

    Benefits: "", // html
    BenefitsDoc: "", // text

    FAQ: "", // html
    FAQDoc: "", // text

    Certification: "", // html
    CertificationDoc: "", // text

    EstimateDelivery: "", // html
    EstimateDeliveryDoc: "", // text

    AuthenticateGemstone: "", // html
    AuthenticateGemstoneDoc: "", // text

    CreatedByUser: "1",
    IsHomePage: false,
    Sold:"",

    Image1: "",
    Image2: "",
    Image3: "",
    Image4: "",
    Image5: "",
    Image6: "",
    Image7: "",
    Image8: "",
    Image9: "",
  });

 

  const [ValueImages, setValueImages] = useState([]);
  const [removedImageIndexes, setRemovedImageIndexes] = useState([]);

const [gemError, setGemError] = useState("");
const [checkingGem, setCheckingGem] = useState(false);


  const ChangeDropDown = (e, name) => {
    if (e) {
      if (name === "IsActive") {
        SetValue((prevValue) => ({
          ...prevValue,
          [name]: e.value,
        }));
      } else {
        SetValue((prevValue) => ({
          ...prevValue,
          CategoryID: e.value,
          Category: e.label,
        }));
      }
    } else {
      SetValue((prevValue) => ({
        ...prevValue,
        [name]: "",
      }));
    }
  };
  
  useEffect(() => {
    dispatch(get_GemstoneCategory_GetDropDawnData());
  }, []);

  useEffect(() => {
    if (GemstoneID) {
      dispatch(get_Gemstone_Singledata(GemstoneID));
    }
  }, [GemstoneID]);

  useEffect(() => {
    if (modalOpen && GemstoneID == null) {
      SetValue({
        HeadingDescription: "",
        CategoryID: "",
        Category: "",
        originalPrice: "",
        Discount: "",
        CurrentPrice: "",
        GSTAmt: "",
        GSTinfo: "",
        TotalAmt: "",
        Carat: "",
        Ratti: "",
        IsActive: true,
        DetailDescription: "",
        DetailDescriptionDoc: "",
        ShortDescription: "",
        Benefits: "",
        BenefitsDoc: "",
        FAQ: "",
        FAQDoc: "",
        Certification: "",
        CertificationDoc: "",
        EstimateDelivery: "",
        EstimateDeliveryDoc: "",
        AuthenticateGemstone: "",
        AuthenticateGemstoneDoc: "",
        CreatedByUser: "1",
        IsHomePage: false,
        Sold: "",
        Image1: "",
        Image2: "",
        Image3: "",
        Image4: "",
        Image5: "",
        Image6: "",
        Image7: "",
        Image8: "",
        Image9: "",
      });
      setFile(null);
      setEditValue(null);
      setValueImages([]);
      setThumImage(null);
    }
  }, [modalOpen, GemstoneID]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0 && GemstoneID != null) {
      SetValue({
        ...Value,
        GemstoneID: GemstoneID,
        HeadingDescription: EditValue[0]?.HeadingDescription,
        CategoryID: EditValue[0]?.CategoryID,
        Category: EditValue[0]?.Category,
        originalPrice: EditValue[0]?.originalPrice,
        Discount: EditValue[0]?.Discount, //added
        CurrentPrice: EditValue[0]?.CurrentPrice,
        GSTAmt: EditValue[0]?.GSTAmt,
        GSTinfo: EditValue[0]?.GSTinfo,
        TotalAmt: EditValue[0]?.TotalAmt,
        Carat: EditValue[0]?.Carat,
        Ratti: EditValue[0]?.Ratti,
        IsActive: EditValue[0]?.IsActive, // Status
        DetailDescription: EditValue[0]?.DetailDescription,
        DetailDescriptionDoc: EditValue[0]?.DetailDescriptionDoc,
        ShortDescription: EditValue[0]?.ShortDescription, // html
        Benefits: EditValue[0]?.Benefits, // html
        BenefitsDoc: EditValue[0]?.BenefitsDoc,
        FAQ: EditValue[0]?.FAQ, // html
        FAQDoc: EditValue[0]?.FAQDoc,
        Certification: EditValue[0]?.Certification, // html
        CertificationDoc: EditValue[0]?.CertificationDoc,
        EstimateDelivery: EditValue[0]?.EstimateDelivery, // html
        AuthenticateGemstone: EditValue[0]?.AuthenticateGemstone, // html
        IsHomePage: EditValue[0]?.IsHomePage,
        Sold:EditValue[0]?.Sold ?? "",
        CreatedByUser: "1",
        Image1: EditValue[0]?.Image1,
        Image2: EditValue[0]?.Image2,
        Image3: EditValue[0]?.Image3,
        Image4: EditValue[0]?.Image4,
        Image5: EditValue[0]?.Image5,
        Image6: EditValue[0]?.Image6,
        Image7: EditValue[0]?.Image7,
        Image8: EditValue[0]?.Image8,
        Image9: EditValue[0]?.Image9,
      });
      setValueImages(
        [
          EditValue[0]?.Image1,
          EditValue[0]?.Image2,
          EditValue[0]?.Image3,
          EditValue[0]?.Image4,
          EditValue[0]?.Image5,
          EditValue[0]?.Image6,
          EditValue[0]?.Image7,
          EditValue[0]?.Image8,
          EditValue[0]?.Image9,
        ]
          .filter(Boolean)
          .map((url) =>
            url ? { preview: `https://${url.replace(/\\/g, "/")}` } : null
          )
          .filter(Boolean)
      );
    }
  }, [EditValue, GemstoneID]);


function sanitizeQuillValue(value) {
  if (!value) return ""; 
  const stripped = value.replace(/<(.|\n)*?>/g, "").trim(); 
  return stripped.length === 0 ? "" : value; 
}






  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";

    if (Value?.CurrentPrice === "") {
      error = true;
      errorMsg = "Please fill CurrentPrice.";
    }
    if (Value?.TotalAmt === "") {
      error = true;
      errorMsg = "Please fill Total Amount.";
    }
    if (Value?.originalPrice === "") {
      error = true;
      errorMsg = "Please fill  Price.";
    }
    if (Value?.Category === "") {
      error = true;
      errorMsg = "Please fill Category.";
    }
    if (Value?.HeadingDescription?.trim() === "") {
      error = true;
      errorMsg = "Please fill Gemstone Name.";
    }
    if (Value?.DetailDescription?.trim() === "") {
      error = true;
      errorMsg = "Please fill Detail Description.";
    }
    if (Value?.ShortDescription?.trim() === "") {
      error = true;
      errorMsg = "Please fill Short Description.";
    }

    if (gemError) {
  error = true;
  errorMsg = "Gemstone name already exists";
}
    
    if (!error) {
  try {
    const formData = new FormData();

    if (thumImage) {
      formData.append("image1", thumImage);
    }

    ValueImages.forEach((item, idx) => {
      if (item.file) {
        formData.append(`Image${idx + 2}`, item.file);
      }
    });

    const valueCopy = { ...Value };
    for (let i = 1; i <= 9; i++) {
      delete valueCopy[`Image${i}`];
    }

    formData.append("Data", JSON.stringify(valueCopy));

    const response = await AddUpdate("Gemstone/Insert_Gemstone", formData);
   

    if (response?.data?.success) {
      
      let message = response?.data?.Message || "Successfully Added";
      try {
        const parsedData = JSON.parse(response?.data?.data || "{}");
        if (parsedData?.Table?.[0]?.Message) {
          message = parsedData.Table[0].Message;
        }
      } catch (parseErr) {
        console.warn("Gemstone response parse failed:", parseErr);
      }

      // onClose();
      navigate("/GemstoneList")
      dispatch(get_Gemstone_GetData_GemData(IsActive));
      swal("Good job!", message, "success");
      setValueImages([]);
      setThumImage(null);
      Reset();
    } else {
      swal("Oops", response?.data?.Message || "Something went wrong!", "error");
    }
  } catch (e) {
    console.error("Gemstone Insert Error:", e);
    swal("Oops", e.message || "Failed to insert gemstone. Try again later.", "error");
  }
}

    else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormUpdate = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";

    if (Value?.CurrentPrice === "") {
      error = true;
      errorMsg = "Please fill CurrentPrice.";
    }
    if (Value?.TotalAmt === "") {
      error = true;
      errorMsg = "Please fill Total Amount.";
    }
    if (Value?.originalPrice === "") {
      error = true;
      errorMsg = "Please fill original Price.";
    }
    if (Value?.Category === "") {
      error = true;
      errorMsg = "Please fill Category.";
    }
    if (Value?.HeadingDescription?.trim() === "") {
      error = true;
      errorMsg = "Please fill Gemstone Name.";
    }
    if (Value?.DetailDescription?.trim() === "") {
      error = true;
      errorMsg = "Please fill DetailDescription.";
    }
    if (Value?.ShortDescription?.trim() === "") {
      error = true;
      errorMsg = "Please fill Detail Description.";
    }

  if (gemError) {
  error = true;
  errorMsg = "Gemstone name already exists";
}
   
    if (!error) {
  try {
   

const sanitizedValue = {
      ...Value,
      ShortDescription: sanitizeQuillValue(Value.ShortDescription),
      Benefits: sanitizeQuillValue(Value.Benefits),
      FAQ: sanitizeQuillValue(Value.FAQ),
      Certification: sanitizeQuillValue(Value.Certification),
      EstimateDelivery: sanitizeQuillValue(Value.EstimateDelivery),
      AuthenticateGemstone: sanitizeQuillValue(Value.AuthenticateGemstone),
      DetailDescription: sanitizeQuillValue(Value.DetailDescription),

    
      BenefitsDoc: sanitizeQuillValue(Value.BenefitsDoc),
      FAQDoc: sanitizeQuillValue(Value.FAQDoc),
      CertificationDoc: sanitizeQuillValue(Value.CertificationDoc),
      EstimateDeliveryDoc: sanitizeQuillValue(Value.EstimateDeliveryDoc),
      AuthenticateGemstoneDoc: sanitizeQuillValue(Value.AuthenticateGemstoneDoc),
      DetailDescriptionDoc: sanitizeQuillValue(Value.DetailDescriptionDoc),
      
    };

   
    const response = await AddUpdate("Gemstone/UpDate_Gemstone", sanitizedValue);


    // const response = await AddUpdate("Gemstone/UpDate_Gemstone", Value);
    

    if (response?.data?.success) {
      
      let message = response?.data?.Message || "Successfully Updated";
      try {
        const parsedData = JSON.parse(response?.data?.data || "{}");
        if (parsedData?.Table?.[0]?.Message) {
          message = parsedData.Table[0].Message;
        }
      } catch (parseErr) {
        console.warn("Gemstone update response parse failed:", parseErr);
      }

      dispatch(get_Gemstone_GetData_GemData(IsActive));
      swal("Good job!", message, "success");
  navigate("/GemstoneList")
      setValueImages([]);
      setThumImage(null);
      setFile(null);
    } else {
      swal("Oops", response?.data?.Message || "Update failed!", "error");
    }
  } catch (e) {
    console.error("Gemstone Update Error:", e);
    swal("Oops", e.message || "Failed to update gemstone. Try again later.", "error");
  }
}

    
    else {
      swal("Oops", errorMsg, "error");
    }
  };


  

  useEffect(() => {
    setEditValue(GemstoneSingledata);
  }, [GemstoneSingledata]);

  const Reset = () => {
  
    SetValue({
      ...Value,
      HeadingDescription: "",
      RegMobileNo: "",
      CurrentPrice: "",
      CreatedTime: "",
      GSTinfo: "",
      GSTAmt: "",
      TotalAmt: "",
      PujaFor: "",
      originalPrice: "",
      Ratti: "",
      originalPrice: "",
      Category: "",
      CurrentPrice: "",
      DetailDescription: "",
      ShortDescription: "",
      Carat: "",
      Ratti: "",
      Description: "",
      FAQ: "",
      AuthenticateGemstone: "",
      EstimateDelivery: "",
      Certification: "",
      BenefitsDoc: "",
      FAQDoc: "",
      CertificationDoc: "",
      EstimateDeliveryDoc: "",
      AuthenticateGemstoneDoc: "",
      IsHomePage: false,
      Sold:""
    });
  };
        
const handleChange = (e) => {

  const { name, value } = e.target;
  let updatedValue = { ...Value, [name]: value };

  // 🔹 Carat <-> Ratti conversion
  if (name === "Carat") {
    const carat = parseFloat(value) || 0;
    updatedValue.Ratti = carat ? (carat * 1.1).toFixed(2) : "";
  } else if (name === "Ratti") {
    const ratti = parseFloat(value) || 0;
    updatedValue.Carat = ratti ? (ratti * 0.91).toFixed(2) : "";
  }

  
  const originalPrice = parseFloat(updatedValue.originalPrice) || 0;
  const discount = parseFloat(updatedValue.Discount) || 0;
  const price = originalPrice - (originalPrice * discount) / 100;
  updatedValue.CurrentPrice = Math.round(price);

  const gstPercentage = parseFloat(updatedValue.GSTinfo) || 0;
  const gstAmt = (price * gstPercentage) / 100;
  updatedValue.GSTAmt = Math.round(gstAmt);

  updatedValue.TotalAmt = Math.round(price + gstAmt);

  SetValue(updatedValue);
};





  const [thumImage, setThumImage] = useState(null);

  const fileHandler = (e) => {
    const file = e.target.files[0];
    const allowedExtensions =
      /(\.apng|\.png|\.jpg|\.jpeg|\.jfif|\.pjpeg|\.pjp)$/i;
    if (file) {
      if (allowedExtensions.exec(file.name)) {
        setFile(file);
      } else {
        swal("Please upload a valid image file");
      }
    }
  };

  const updateIndexZero = (e) => {
    const file = e.target.files[0];
    setThumImage(file);
  };

  const handleUpdatePhoto = async () => {
    if (
      !thumImage &&
      ValueImages.length === 0 &&
      removedImageIndexes.length === 0
    ) {
      swal(
        "Error",
        "Please select at least one image to upload or remove",
        "error"
      );
      return;
    }

    const formData = new FormData();

    if (thumImage) {
      formData.append("Image1", thumImage);
    }

    ValueImages.forEach((item, idx) => {
      if (item.file) {
        formData.append(`Image${idx + 2}`, item.file);
      }
    });

    // removedImageIndexes.forEach((imageIndex) => {
    //   formData.append(`Image${imageIndex}`, null);
    removedImageIndexes.forEach((imageIndex) => {
      const emptyFile = new File([""], "empty.jpg", { type: "image/jpeg" });
      formData.append(`Image${imageIndex}`, emptyFile);
    });

    const dataObject = {
      GemstoneID: GemstoneID,
      ModifiedByUser: "1",
    };
    formData.append("Data", JSON.stringify(dataObject));

    try {
      await AddUpdate("Gemstone/UpdatePhoto_Gemstone", formData);
      swal("Good job!", "Successfully Added", "success");
      setValueImages([]);
      setThumImage(null);
      setRemovedImageIndexes([]);
    } catch (error) {
      swal("Error", "Failed to upload photo", "error");
    }
  };

  const OnChangeEditor = (value, name) => {
    SetValue((prevValue) => ({ ...prevValue, [name]: value }));
  };

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #fdba74",
      borderRadius: 6,
      fontSize: 14,
      backgroundColor: "#fff",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(253, 186, 116, 0.2)"
        : "none",
      borderColor: state.isFocused ? "#fdba74" : "#fdba74",
      minHeight: 39,
      outline: "none",
      ":hover": {
        borderColor: "#fdba74",
      },
    }),
    input: (provided) => ({
      ...provided,
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
  };

  // Clean up object URLs on unmount
  useEffect(() => {
    return () => {
      ValueImages.forEach((item) => {
        if (item && item.preview) {
          URL.revokeObjectURL(item.preview);
        }
      });
    };
  }, [ValueImages]);

const modules = {
    toolbar: [
     
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ header: 1 }, { header: 2 },{ header: 3 }],
      [{ font: [] }],
      [{ size: [] }],

     
      ["bold", "italic", "underline", "strike"], 
      [{ script: "sub" }, { script: "super" }], 
      [{ color: [] }, { background: [] }], 

      
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],

      
      ["blockquote", "code-block"],

    
      ["link", "image", "video", "formula"],

      
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "script",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "blockquote",
    "code-block",
    "link",
    "image",
    "video",
    // "formula",
  ];

const checkGemExist = async (value) => {
  if (!value) {
    setGemError("");
    return;
  }

  try {
    setCheckingGem(true);

    const payload = {
      GemstoneID: Value.GemstoneID || 0,
      HeadingDescription: value,
    };

    const res = await AddUpdate("Gemstone/GemstoneCheckNameExist", payload);

    // 👇 parse response (same pattern)
    const parsed = JSON.parse(res?.data?.data || "{}");
    const exist = parsed?.Table?.[0]?.GemstoneExist;

    if (exist == 1) {
      setGemError("Gemstone name already exists");
    } else {
      setGemError("");
    }

  } catch (err) {
    console.log("Gem check error", err);
  } finally {
    setCheckingGem(false);
  }
};

useEffect(() => {
  const timer = setTimeout(() => {
    checkGemExist(Value.HeadingDescription);
  }, 500);

  return () => clearTimeout(timer);
}, [Value.HeadingDescription]);





  return (
    <>
      <style>{quillBorderedStyle}</style>
      <form
        className="form-card"
        onSubmit={GemstoneID ? handleAddFormUpdate : handleAddFormSubmit}
      >
  <div className="button-group">
              {GemstoneID ? (
               <>
  <button
    className="btn btn-primary me-2"
    type="submit"
    onClick={handleAddFormUpdate}
  >
    Update
  </button>

  <button
  style={{backgroundColor:"green"}}
    className="btn btn-primary me-2"
    type="submit"
    onClick={handleAddFormSubmit}
  >
    New
  </button>

  <button
  style={{backgroundColor:"red"}}
    className="btn btn-danger"
    type="button"
    onClick={() => navigate("/GemstoneList")}
  >
    Close
  </button>
</>

              ) : (
                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={handleAddFormSubmit}
                >
                  Save
                </button>
              )}
            </div>

        <div className="row ">
          <div className="col-xl-12">
            <div className="">
              <div className="row">
                <div className="col-10">
                  <div className="row">
                    <div className="form-group mb-3 col-6">
                      <label className="text-black font-w500">
                        Gemstone Name
                        <span className="text-danger star-error">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="text"
                          autoComplete="off"
                          name="HeadingDescription"
                          required="required"
                          value={Value.HeadingDescription}
                          placeholder="Gemstone Name"
                          onChange={handleChange}
                        />
{gemError && (
  <small className="text-danger">{gemError}</small>
)}

{checkingGem && (
  <small>Checking...</small>
)}

                      </div>
                    </div>
                    <div className="form-group mb-3 col-6">
                      <label>
                        Category{" "}
                        <span className="text-danger star-error">*</span>
                      </label>

                      <Select
                        className="custom-select-wrapper"
                        name="CategoryID"
                        value={GemstoneCategoryGetDropDawnData?.find(
                          (obj) => obj.value === Value?.CategoryID
                        )}
                        options={GemstoneCategoryGetDropDawnData}
                        onChange={(e) => ChangeDropDown(e, "CategoryID")}
                        placeholder="Select Highest Category"
                        isClearable
                        styles={customSelectStyles}
                      />
                    </div>

                    <div className="form-group mb-3 col-4">
                      <label className="text-black font-w500">
                        Price (₹){" "}
                        <span className="text-danger star-error">*</span>
                      </label>
                      <input
                        type="number"
                        name="originalPrice"
                        placeholder="Enter price"
                        value={Value.originalPrice}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group mb-3 col-4">
                      <label className="text-black font-w500">
                        Discount (%)
                      </label>
                      <input
                        type="number"
                        name="Discount"
                        placeholder="Enter original price"
                        value={Value.Discount}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group mb-3 col-4">
                      <label className="text-black font-w500">
                        Current Price{" "}
                        <span className="text-danger star-error">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="number"
                          autoComplete="off"
                          name="CurrentPrice"
                          required="required"
                          value={Value.CurrentPrice}
                          placeholder="Select CurrentPrice.."
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group mb-3 col-4">
                      <label className="text-black font-w500">GST Info</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          autoComplete="off"
                          onChange={handleChange}
                          name="GSTinfo"
                          required="required"
                          value={Value.GSTinfo}
                          placeholder="Gst %"
                          maxLength={200}
                        />
                      </div>
                    </div>

                    <div className="form-group mb-3 col-4">
                      <label className="text-black font-w500">GST Amt</label>
                      <div className="contact-name">
                        <input
                          type="number"
                          autoComplete="off"
                          onChange={handleChange}
                          name="GSTAmt"
                          required="required"
                          value={Value.GSTAmt}
                          placeholder="GSTAmt"
                          maxLength={200}
                        />
                      </div>
                    </div>

                    <div className="form-group mb-3 col-4">
                      <label className="text-black font-w500">
                        Total Amt{" "}
                        <span className="text-danger star-error">*</span>
                      </label>
                      <div className="contact-name">
                        <input
                          type="number"
                          autoComplete="off"
                          onChange={handleChange}
                          name="TotalAmt"
                          required="required"
                          value={Value.TotalAmt}
                          placeholder="TotalAmt"
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Short Description{" "}
                        <span className="text-danger star-error">*</span>
                      </label>
                      <div className="contact-name">
                        <textarea
                          rows={3}
                          cols={6}
                          autoComplete="off"
                          onChange={handleChange}
                          name="ShortDescription"
                          required="required"
                          value={Value.ShortDescription}
                          placeholder="Enter ShortDescription"
                          // maxLength={200}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-2">
                  <div className="profile-head">
                    <div className="profile-info">
                      <div className="profile-photo">
                        <div
                          className="image-container d-flex justify-content-start"
                          style={{ gap: "1rem" }}
                        >
                          <div className="image-placeholder">
                            <div className="avatar-edit">
                              <input
                                type="file"
                                id="imageUpload"
                                accept="image/*"
                                onChange={(e) => updateIndexZero(e)}    
                              />
                              <label htmlFor="imageUpload" />
                            </div>
                            <div className="avatar-preview">
                              <div id="ImagePreview">
                                {(thumImage instanceof File ||
                                  (GemstoneID && Value.Image1)) && (
                                  <img
                                    src={
                                      thumImage instanceof File
                                        ? URL.createObjectURL(thumImage)
                                        : GemstoneID && Value.Image1
                                        ? `https://${Value.Image1.replace(
                                            /\\/g,
                                            "/"
                                          )}`
                                        : ""
                                    }
                                    style={{
                                      width: "100%",
                                      height: "auto",
                                      objectFit: "cover",
                                    }}
                                    alt="preview"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                   
                    {GemstoneID ? (
  <button
    onClick={handleUpdatePhoto}
    style={{
      backgroundColor: "#17a2bb",
      color: "white",
      padding: "8px 35px",
      border: "none",
      borderRadius: "6px",
      marginRight:"10px",
      cursor: "pointer",
      fontWeight: "500",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      transition: "all 0.3s ease"
    }}
   
  >
     Upload Images
  </button>
) : " "}

                </div>
              </div>
              <div className="row">
                <div className="form-group mb-3">
                  <label className="text-black font-w500">
                    Detail Description{" "}
                    <span className="text-danger star-error">*</span>
                  </label>
                  <div className="custom-ekeditor">
                  <ReactQuill
                    value={Value.DetailDescription}
                    onChange={(value, delta, source, editor) => {
                      const text = editor?.getText();
                      SetValue((prevValue) => ({
                        ...prevValue,
                        DetailDescription: value,
                        DetailDescriptionDoc: text,
                      }));
                    }}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                    placeholder="Write something..."
                    className="quill-bordered"
                  />
                  </div>
                </div>
                <div className="form-group mb-3 col-3">
                  <label className="text-black font-w500"> Carat</label>
                  <div className="contact-name">
                    <input
                      type="number"
                      rows={3}
                      cols={6}
                      autoComplete="off"
                      onChange={handleChange}
                      name="Carat"
                      required="required"
                      value={Value.Carat}
                      placeholder="Enter Carat"
                      maxLength={200}
                    />
                  </div>
                </div>
                <div className="form-group mb-3 col-3">
                  <label className="text-black font-w500"> Ratti</label>
                  <div className="contact-name">
                    <input
                      autoComplete="off"
                      onChange={handleChange}
                      name="Ratti"
                      required="required"
                      value={Value.Ratti}
                      placeholder="Enter Ratti"
                      maxLength={200}
                    />
                  </div>
                </div>
              <div className="form-group mb-3 col-3">
                  <label className="text-black font-w500"> Sold</label>
                  <div className="contact-name">
                    <input
                      autoComplete="off"
                      onChange={handleChange}
                      name="Sold"
                      // required="required"
                      value={Value.Sold}
                      placeholder="Enter Sold"
                      maxLength={200}
                    />
                  </div>
                </div>

                <div className="form-group mb-3 col-3">
                  <label className="text-black font-w500">Status</label>
                  <Select
                    name="IsActive"
                    value={[
                      { value: true, label: "Active" },
                      { value: false, label: "Inactive" },
                    ].find((opt) => opt.value === Value.IsActive)}
                    options={[
                      { value: true, label: "Active" },
                      { value: false, label: "Inactive" },
                    ]}
                    onChange={(e) => ChangeDropDown(e, "IsActive")}
                    placeholder="Select Status"
                    isClearable
                    styles={customSelectStyles}
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="text-black font-w500">Benefits</label>
                
                  <ReactQuill
                    value={Value.Benefits}
                    onChange={(value, delta, source, editor) => {
                      const text = editor?.getText();
                      SetValue((prevValue) => ({
                        ...prevValue,
                        Benefits: value,
                        BenefitsDoc: text,
                      }));
                    }}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                    placeholder="Write something..."
                    className="quill-bordered"
                  />
                
                </div>
                <div className="form-group mb-3">
                  <label className="text-black font-w500">FAQ</label>
                  <div className="custom-ekeditor">
                  <ReactQuill
                    value={Value.FAQ}
                    onChange={(value, delta, source, editor) => {
                      const text = editor?.getText();
                      SetValue((prevValue) => ({
                        ...prevValue,
                        FAQ: value,
                        FAQDoc: text,
                      }));
                    }}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                    placeholder="Write something..."
                    className="quill-bordered"
                  />
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label className="text-black font-w500">Certification </label>
                 
                  <ReactQuill
                    value={Value.Certification}
                    onChange={(value, delta, source, editor) => {
                      const text = editor?.getText();
                      SetValue((prevValue) => ({
                        ...prevValue,
                        Certification: value,
                        CertificationDoc: text,
                      }));
                    }}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                    placeholder="Write something..."
                    className="quill-bordered"
                  />
                
                </div>
                <div className="form-group mb-3">
                  <label className="text-black font-w500">
                    Estimated Delivery
                  </label>
                 
                  <ReactQuill
                    value={Value.EstimateDelivery}
                    onChange={(value, delta, source, editor) => {
                      const text = editor?.getText();
                      SetValue((prevValue) => ({
                        ...prevValue,
                        EstimateDelivery: value,
                        EstimateDeliveryDoc: text,
                      }));
                    }}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                    placeholder="Write something..."
                    className="quill-bordered"
                  />
                 
                </div>
                <div className="form-group mb-3">
                  <label className="text-black font-w500">
                    Authentic Gemstone
                  </label>
                
                  <ReactQuill
                    value={Value.AuthenticateGemstone}
                    onChange={(value, delta, source, editor) => {
                      const text = editor?.getText();
                      SetValue((prevValue) => ({
                        ...prevValue,
                        AuthenticateGemstone: value,
                        AuthenticateGemstoneDoc: text,
                      }));
                    }}
                    modules={modules}
                    formats={formats}
                    theme="snow"
                    placeholder="Write something..."
                    className="quill-bordered"
                  />
               
</div>
                <div className="form-group mb-3 col-4">
                  <label className="text-black font-w500">Is Home Page</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      name="IsHomePage"
                      checked={Value?.IsHomePage || false}
                      onChange={(e) =>
                        SetValue((prev) => ({
                          ...prev,
                          IsHomePage: e.target.checked,
                        }))
                      }
                      className="form-check-input p-0"
                      style={{
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                      id="isHomePageCheckbox"
                    />
                  </div>
                </div>

                <div className="form-group mb-4 col-12">
                  <label className="text-black font-w500 mb-2">Gallery</label>
                  <div
                    className="position-relative d-flex align-items-center"
                    style={{ height: "40px" }}
                  >
                    <input
                      type="file"
                      name="Gallery"
                      multiple                        
                      accept="image/*"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        padding: "0.375rem 0.75rem",
                      }}
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        const filesWithPreview = files.map((file) => ({
                          file,
                          preview: URL.createObjectURL(file),
                        }));
                        setValueImages((prev) => [
                          ...prev,
                          ...filesWithPreview,
                        ]);
                      }}
                    />
                  </div>

                {ValueImages?.length > 1 && (
  <div className="row mt-3">
    {ValueImages.slice(1).map((item, index) => {
      const actualIndex = index + 1; 
      return (
        <div
          key={actualIndex}
          className="col-12 col-sm-6 col-md-4 mb-3 position-relative"
        >
          <button
            type="button"
            className="btn btn-sm btn-danger position-absolute"
            style={{
              top: "5px",
              right: "5px",
              zIndex: 2,
              padding: "2px 6px",
              borderRadius: "50%",
              fontSize: "12px",
              lineHeight: 1,
            }}
            onClick={() => {
              const updated = [...ValueImages];
              const [removed] = updated.splice(actualIndex, 1);

              if (!removed.file) {
                setRemovedImageIndexes((prev) => [
                  ...prev,
                  actualIndex + 1,
                ]);
              }

              if (removed?.preview?.startsWith("blob:")) {
                URL.revokeObjectURL(removed.preview);
              }

              setValueImages(updated);
            }}
          >
            ×
          </button>

          <div className="border rounded overflow-hidden shadow-sm">
            <img
              src={item.preview}
              alt={`preview-${actualIndex}`}
              className="img-fluid"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      );
    })}
  </div>
)}


                  
                </div>
               
                {GemstoneID ? (
                  <div className="text-center my-3">
                    <button
                      onClick={handleUpdatePhoto}
                      className="btn btn-outline-primary shadow-sm px-4 py-2 rounded-pill"
                      style={{
                        fontWeight: "500",
                        fontSize: "16px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i className="fas fa-upload me-2"></i> Upload Images
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            
          </div>
        </div>
      </form>
    </>
  );
};
export default GemstoneAdd;
